import dayjs, { Dayjs } from 'dayjs';
import React from 'react';
import { FormattedRelativeTime } from 'react-intl';
import { Props } from 'react-intl/dist/components/relative';
import { Time } from './Time';

interface TempoAtrasProps {
  data: Dayjs;
}

export const TempoAtras: React.FC<TempoAtrasProps & Props> = ({data, ...props}) => {
  const intervaloSegundos = dayjs().diff(data, 'seconds');
  const date = data.toDate();
  
  const UMA_SEMANA_E_UM_DIA = (7+1) * 24 * 60 * 60;

  if (intervaloSegundos > UMA_SEMANA_E_UM_DIA)
    return <span>em <Time data={data}>{date.toLocaleDateString()}</Time></span>

  const numeric = props.numeric || "auto";

  // Valor do intervalo será negativo quando se refere a um intervalo de tempo passado
  return <Time data={data}>
    <FormattedRelativeTime 
      {...props}
      value={-intervaloSegundos}
      numeric={numeric}
      updateIntervalInSeconds={35} />
  </Time>;
}
